import { WireCoverType, WireItemType } from 'scenes/common/api/quote/types';
import { LabelValueType } from 'scenes/common/types';

import { WireHomeQuotePayload } from '../types';

export const unmarshalGeneralPortables = (
  quote: WireHomeQuotePayload
): LabelValueType[] =>
  quote.limits
    .find(
      ({ name, applyTo }) =>
        name === WireItemType.GeneralPortables &&
        Object.values(WireCoverType).includes(applyTo as WireCoverType)
    )
    ?.items.map((item) => ({
      value: item.name || item.description,
      label: item.description,
    })) || [];
